import { Button } from '@synoptic/ui-kit/button/button.tsx';
import {
  Drawer,
  DrawerContent,
  DrawerDescription,
  DrawerFooter,
  DrawerHeader,
  DrawerTitle,
} from '@synoptic/ui-kit/drawer/drawer.tsx';
import { FC } from 'react';
import { useLocation } from 'react-router';
import { getRedirectLink } from '@/routes-utils/get-redirect-link.ts';
import { Link } from '@/routes-utils/navigation.tsx';
import { paths } from '@/routes-utils/paths.ts';
import { actionDrawerDescription } from '../unauthenticated-post-card/unauthenticated-post-card.css.ts';
import { publicDrawerContentInnerContainer } from './unauthenticated-action-drawer.css.ts';

export type UnauthenticatedActionDrawerProps = {
  open: boolean;
  onOpenChange: (open: boolean) => void;
};

export const UnauthenticatedActionDrawer: FC<
  UnauthenticatedActionDrawerProps
> = ({ onOpenChange, open }) => {
  const location = useLocation();

  return (
    <Drawer open={open} onOpenChange={onOpenChange}>
      <DrawerContent>
        <div className={publicDrawerContentInnerContainer}>
          <DrawerHeader>
            <DrawerTitle>Hold on!</DrawerTitle>
            <DrawerDescription className={actionDrawerDescription}>
              To continue, you&apos;ll need to log in or create an account. It
              just takes a moment, and it helps us keep your experience secure
              and personalized.
            </DrawerDescription>
          </DrawerHeader>
          <DrawerFooter>
            <Button size={'large'} asChild>
              <Link to={getRedirectLink(paths.signup, location.pathname)}>
                Sign up
              </Link>
            </Button>
            <Button size={'large'} variant={'secondary'} asChild>
              <Link to={getRedirectLink(paths.login, location.pathname)}>
                Log in
              </Link>
            </Button>
          </DrawerFooter>
        </div>
      </DrawerContent>
    </Drawer>
  );
};
